<p-dialog
  #fastCombustivel
  [modal]="true"
  [visible]="true"
  (visibleChange)="dialogRef.close()"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [maximizable]="true"
  [closable]="true"
  [responsive]="true"
  [closeOnEscape]="false"
  [dismissableMask]="false"
>
  <ng-template pTemplate="header">
    <div class="flex aling-items-center">
      <span class="font-light fs-normal">Adicionar combustível</span>
      <i class="mdi mdi-gas-station-outline ml-2 text-primary"></i>
    </div>
  </ng-template>
  <div class="row p-2">
    <div class="col-md-12 mt-3">
      <span class="p-float-label">
        <input
          id="inputtext-nome"
          class="input-filters"
          pInputText
          [formControl]="form.get('nome')"
          type="text"
          (blur)="actionFnCheckEntityExist(form.get('nome'))"
          autocomplete="off"
        />
        <label for="inputtext-nome">Nome *</label>
      </span>
      <small class="p-error" *ngIf="form.get('nome').hasError('required')">
        {{ displayMessage.nome.required }}
      </small>
      <small class="p-error" *ngIf="form.get('nome').hasError('maxlength')">
        {{ displayMessage.nome.maxlength }}
      </small>
      <small class="p-error" *ngIf="form.get('nome').hasError('isEmptyValue')">
        {{ displayMessage.nome.isEmptyValue }}
      </small>
      <small class="p-error" *ngIf="form.get('nome').hasError('duplicate')">
        {{ displayMessage.nome.duplicate }}
      </small>
    </div>

    <div class="col-md-12 mt-3">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>Valor</mat-label>
        <input
          matInput
          (keydown)="validateOnlyNumbers($event)"
          type="text"
          [formControl]="form.get('valor')"
          style="text-align: right;"
        />
        <span matPrefix *ngIf="form.get('valor').value">R$&nbsp;</span>
      </mat-form-field>
      <small class="p-error" *ngIf="form.get('valor').hasError('required')">
        {{ displayMessage.valor.required }}
      </small>
      <small class="p-error" *ngIf="form.get('valor').hasError('min')">
        {{ displayMessage.valor.min }}
      </small>
      <small class="p-error" *ngIf="form.get('valor').hasError('max_value')">
        {{ displayMessage.valor.max_value }}
      </small>
      <small class="p-error" *ngIf="form.get('valor').hasError('before_split')">
        {{ displayMessage.valor.before_split }}
      </small>
      <small class="p-error" *ngIf="form.get('valor').hasError('after_split')">
        {{ displayMessage.valor.after_split }}
      </small>
      <small class="p-error" *ngIf="form.get('valor').hasError('errorComma')">
        {{ displayMessage.valor.errorComma }}
      </small>
      <small class="p-error" *ngIf="form.get('valor').hasError('errorDots')">
        {{ displayMessage.valor.errorDots }}
      </small>
      <small class="p-error" *ngIf="form.get('valor').hasError('notNumbers')">
        {{ displayMessage.valor.notNumbers }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('valor').hasError('invalidNumber')"
      >
        {{ displayMessage.valor.invalidNumber }}
      </small>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="width-100 mb-3 flex align-items-center justify-content-between">
      <button
        pButton
        pRipple
        severity="danger"
        text
        rounded
        (click)="dialogRef.close()"
        [disabled]="loading"
        label="Cancelar"
        icon="pi pi-fw pi-times-circle"
        iconPos="right"
      ></button>
      <button
        pButton
        pRipple
        severity="success"
        outlined
        rounded
        label="Salvar"
        icon="pi pi-fw pi-save"
        iconPos="right"
        (click)="onSubmit()"
        [disabled]="loading || !form.valid"
      ></button>
    </div>
  </ng-template>
</p-dialog>
